// @flow

import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  min-height: 400px;
`;

export const Content = styled.div`
  margin-top: auto;
  margin-bottom: auto;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: ${props => props.theme.colors.new_primary[500]};
  margin-top: 16px;
  margin-bottom: 12px;
  line-height: 1.2;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${props => props.theme.colors.neutral[600]};
  margin-bottom: 32px;
  line-height: 1.5;
`;

export const FlowIndicator = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FlowRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const EbanxLogo = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FlowText = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.neutral[700]};
`;

export const ArrowDown = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
  padding: 4px 0;
`;

export const BankLogo = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;

export const BankLogoPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.theme.colors.new_primary[50]};
  color: ${props => props.theme.colors.new_primary[500]};
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;
